export default __webpack_public_path__ + "static/media/SackBasicsRolling1.9d2808b6.jpg";